export const preProcessHealthServicesData = vaHealthServicesArray => {
  return vaHealthServicesArray;
};
